export default [
  {
    path: "smb-sales-apply-2025",
    name: "smbSalesApply2025",
    component: () => import("@/views/channelAgreement/twentyTwentyFive/SBG/apply/apply")
  },
  // smb 申请成功
  {
    path: "smb-sales-apply-success-2025",
    name: "smbSalesApplySuccess",
    component: () => import("@/views/channelAgreement/twentyTwentyFive/SBG/apply/applySuccess")
  },
  // smb 审批
  {
    path: "smb-sales-approve-2025",
    name: "smbSalesApprove2025",
    component: () => import("@/views/channelAgreement/twentyTwentyFive/SBG/approve/index")
  },
  // smb续签
  {
    path: "smb-sales-renewal-2025",
    name: "smbSalesRenew2025",
    component: () => import("@/views/channelAgreement/twentyTwentyFive/SBG/renew/renew")
  },
  // smb编辑
  {
    path: "smb-sales-edit-2025",
    name: "smbSalesEdit2025",
    component: () => import("@/views/channelAgreement/twentyTwentyFive/SBG/edit/index")
  },
  // smb重新提交
  {
    path: "smb-sales-resubmit-2025",
    name: "smbSalesResubmit2025",
    component: () => import("@/views/channelAgreement/twentyTwentyFive/SBG/resubmit/index")
  },
  // smb渠道确认
  {
    path: "smb-sales-channel-confirm-2025",
    name: "smbSalesChannelConfirm2025",
    component: () => import("@/views/channelAgreement/twentyTwentyFive/SBG/channelConfirm/channelConfirm")
  },
  // smb渠道确认成功
  {
    path: "smb-sales-channel-confirm_success-2025",
    name: "smbSalesChannelConfirmSuccess2025",
    component: () =>
      import("@/views/channelAgreement/twentyTwentyFive/SBG/channelConfirm/channelConfirmSuccess")
  },
  // smb详情
  {
    path: "smb-sales-detail-2025",
    name: "smbSalesDetail2025",
    component: () => import("@/views/channelAgreement/twentyTwentyFive/SBG/detail/index")
  },
]



// WEBPACK FOOTER //
// ./src/router/smb2025.js